module.exports = __webpack_public_path__ + "img/d08c78f.jpg";